import React, { Fragment, useState } from 'react';
import Navbar from '../../components/Navbar/Navbar'
import PageTitle from '../../components/pagetitle/PageTitle'
import Scrollbar from '../../components/scrollbar/scrollbar'
import { Link, useParams } from 'react-router-dom'
import Services from '../../api/Services';
import Footer from '../../components/footer/Footer';
import ServiceSidebar from './sidebar';
import './ServiceSinglePage.css';

import simg1 from '../../images/about/header.jpg'
import Logo from '../../images/logo.svg'
import icon1 from '../../images/icons/1.png'
import icon2 from '../../images/icons/2.png'
import icon3 from '../../images/icons/3.png'
import icon4 from '../../images/icons/4.png'
import icon5 from '../../images/icons/5.png'
import icon6 from '../../images/icons/6.png'
import icon7 from '../../images/icons/7.png'
import icon8 from '../../images/icons/8.png'
import icon9 from '../../images/icons/9.png'
import ins2 from '../../images/instragram/img-2.jpg'
import ins3 from '../../images/instragram/img-3.jpg'



const accordionData = [
    {
        title: "We Can Save More Lives With Your Helping Hand.",
        content: "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Eum exercitationem pariatur iure nemo esse repellendus est quo recusandae. Delectus, maxime."
    },
    {
        title: "Planning can help alleviate workplace stress and increase productivity.",
        content: "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Eum exercitationem pariatur iure nemo esse repellendus est quo recusandae. Delectus, maxime."
    },
    {
        title: "Those who experiment the most are able to innovate the best.",
        content: "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Eum exercitationem pariatur iure nemo esse repellendus est quo recusandae. Delectus, maxime."
    },
    {
        title: "Understand Your Problem, You must understand the issue.",
        content: "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Eum exercitationem pariatur iure nemo esse repellendus est quo recusandae. Delectus, maxime."
    }
];








const ServiceSinglePage = (props) => {
    const { slug } = useParams()

    const serviceDetails = Services.find(item => item.slug === slug)

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    const [activeAccordion, setActiveAccordion] = useState(null);

    const toggleAccordion = (index) => {
        setActiveAccordion(activeAccordion === index ? null : index);
    };

    return (
        <Fragment>
            <Navbar Logo={Logo} hclass={'wpo-site-header-s5'} />
            {/* <PageTitle pageTitle={"About Us"} pagesub={'About Us'} /> */}
            <div className="impact-video-wrapper">
            <video autoPlay
            loop
            muted>
            <source src="videos/video1.mp4" type="video/mp4" />
          </video>            
          </div>
            <section className="wpo-service-single-section section-padding">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 col-md-12">

                            <div className="wpo-service-single-wrap">
                                <div className='row'>
                                    <div className="col-lg-8 col-md-12">
                                <div className="wpo-service-single-content">
                                    <div className="wpo-service-single-content-des about">
                                        <h2>About Us</h2>
                                        <p>Heart to Heart Children’s Aid Foundation is a life-saving initiative dedicated to providing 
free heart surgeries for Ethiopia’s most vulnerable children. Founded by Mr. Birhan Tedla, 
owner of Ethio-Istanbul General Hospital, after witnessing the heartbreaking loss of 
children who couldn’t access care, the foundation has become a beacon of hope for 
families with nowhere else to turn. Heart to Heart Children’s Aid has given <span>322</span> children free, life-saving cardiac surgeries, restoring hope to families and giving countless children a second chance at a healthy future.</p>
                                        <p>The need in Ethiopia is urgent and overwhelming. More than <span>25,000</span> children are currently 
waiting for heart surgery, and many will not survive without timely treatment. Congenital 
and Rheumatic Heart Disease alone affects <span> 6.4 per 1,000</span> schoolchildren, making it one of 
the most widespread and devastating childhood illnesses in the country. Most of the 
children the foundation serves are under the age of five, many have complex conditions 
such as Down syndrome, and over <span>70%</span> travel more than <span>700 kilometers</span> from remote areas 
just to reach care. These are children who have been turned away elsewhere, yet through 
the foundation, they receive a real chance at life. Adding to this hardship, many of these 
families do not have the financial capacity to travel within Ethiopia or cover even their basic 
expenses, making access to lifesaving treatment nearly impossible without support.</p>

<p>Looking ahead, Heart to Heart Children’s Aid is committed to expanding its impact by 
scaling to <span>1000</span> free heart surgeries every year. This bold mission is built on proven 
success and a deep belief that every child deserves a strong, healthy heart. Supporters can 
join this mission by donating, sponsoring a child’s surgery, or partnering with the 
foundation to strengthen pediatric cardiac care across Ethiopia. Every contribution, no 
matter the size, directly helps restore health, hope, and a future to a child in need.</p>
                                        {/* <div className="wpo-service-single-sub-img">
                                            <ul>
                                                <li><img src={simg1} alt="img" /></li>
                                                <li><img src={simg2} alt="img" /></li>
                                            </ul>

                                        </div> */}
                                        <div className="row">
                                            <div className="col-lg-12 col-md-6 col-12" >
                                                <div className="wpo-solutions-item">
                                                    <div className="wpo-solutions-icon">
                                                        {/* <div className="icon">
                                                            <img src="" alt="img" />
                                                        </div> */}
                                                    </div>
                                                    <div className="wpo-solutions-text">
                                                        <h2>Our Mission</h2>
                                                        <p>Inspired by the generosity and passion of the founder, Mr. Berhan Tedla, Heart to Heart Children's Aid dedicated to provide free, high quality cardiac care and surgical Interventional support to <span>1000</span> children each year from low income families in Ethiopia. We work to improve survival, restore hope and promote long-term wellbeing by partnering with medical institutions, including the founder's own Ethio-Istanbul General Hospital.</p>
                                                    </div>
                                                </div>
                                            </div>
                                             <div className="col-lg-12 col-md-6 col-12" >
                                                <div className="wpo-solutions-item">
                                                    <div className="wpo-solutions-icon">
                                                        {/* <div className="icon">
                                                            <img src="" alt="img" />
                                                        </div> */}
                                                    </div>
                                                    <div className="wpo-solutions-text">
                                                        <h2>Our Vision</h2>
                                                        <p>A future where every child in Ethiopia, regardless of Economic background, has access to life saving cardiac care care the opportunity to grow up healthy, strong and full of potential.</p>
                                                    </div>
                                                </div>
                                            </div>
                                             
                                    </div>
                                    </div>
                                </div>
                                </div>
<div className="col-lg-4 col-md-8">
                            <ServiceSidebar />
                        </div>                                
                        </div>
                          <div className="wpo-solutions-section">
                                    
                                </div>
                                <div className="wpo-solutions-section">
                                    <h2>Our Values</h2>
                                    <div className="row">
                                            <div className="col col-md-6 col-sm-12 col-12 value-col" >
                                                <div className="wpo-solutions-item" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                    <div className="wpo-solutions-icon">
                                                        <div className="icon">
                                                            <img src={icon4} alt="img" />
                                                        </div>
                                                    </div>
                                                    <div className="wpo-solutions-text" >
                                                        <h2>Compassion</h2>
                                                        {/* <p>We lead with love and empathy for every child and family</p> */}
                                                    </div>
                                                </div>
                                            </div>
                                             <div className="col col-md-6 col-sm-12 col-12 value-col">
                                                <div className="wpo-solutions-item" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                    <div className="wpo-solutions-icon">
                                                        <div className="icon">
                                                            <img src={icon2} alt="img" />
                                                        </div>
                                                    </div>
                                                    <div className="wpo-solutions-text">
                                                        <h2>Collaboration</h2>
                                                        {/* <p>We work hand-in-hand with hospitals, doctors, and global partners</p> */}
                                                    </div>
                                                </div>
                                            </div>
                                           
                                             
                                             <div className="col col-md-6 col-sm-12 col-12 value-col">
                                                <div className="wpo-solutions-item" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                    <div className="wpo-solutions-icon">
                                                        <div className="icon">
                                                            <img src={icon9} alt="img" />
                                                        </div>
                                                    </div>
                                                    <div className="wpo-solutions-text">
                                                        <h2>Sustainability</h2>
                                                        {/* <p>We create lasting solutions to ensure long-term health and wellness for children.</p> */}
                                                    </div>
                                                </div>
                                            </div>
                                             
                                             <div className="col col-md-6 col-sm-12 col-12 value-col">
                                                <div className="wpo-solutions-item" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                    <div className="wpo-solutions-icon">
                                                        <div className="icon">
                                                            <img src={icon7} alt="img" />
                                                        </div>
                                                    </div>
                                                    <div className="wpo-solutions-text">
                                                        <h2>Equity</h2>
                                                        {/* <p>We ensure fair and equal access to life-saving healthcare for every child, regardless of their circumstances.</p> */}
                                                    </div>
                                                </div>
                                            </div>
                                             
                                             <div className="col col-md-6 col-sm-12 col-12 value-col">
                                                <div className="wpo-solutions-item" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                    <div className="wpo-solutions-icon">
                                                        <div className="icon">
                                                            <img src={icon3} alt="img" />
                                                        </div>
                                                    </div>
                                                    <div className="wpo-solutions-text">
                                                        <h2>Commitment</h2>
                                                        {/* <p>We dedicate our resources, time, and energy to saving lives</p> */}
                                                    </div>
                                                </div>
                                            </div>
                                    </div>
                                </div>
                               <div className="wpo-benefits-section py-5">
  <div className="container">
    
    <h2 className="text-center mb-5 fw-bold">
      Patient Source
    </h2>

    <div className="row g-4 justify-content-center">
      
      {/* Certificate (short image) */}
      <div className="col-md-6 col-lg-5">
        <div className="custom-card">
          <img 
            src={ins2} 
            alt="Patient Source 1"
            className="custom-img contain"
          />
        </div>
      </div>

      {/* PDF (tall image) */}
      <div className="col-md-6 col-lg-5">
        <div className="custom-card">
          <img 
            src={ins3} 
            alt="Patient Source 2"
            className="custom-img cover"
          />
        </div>
      </div>

    </div>

  </div>
</div>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </section>
            <Footer />
            <Scrollbar />
        </Fragment>
    )
};
export default ServiceSinglePage;


